@if (innerForm) {
  <form [formGroup]="innerForm">
    <label class="margin-bottom-sm fw-bold" [for]="domID">
      {{ label | translate }}
    </label>
    @if (description) {
      <p class="margin-bottom-xs font-size-s description" data-test-id="multivalue-input-description">
        {{ description | translate }}
      </p>
    }
    <input
      type="text"
      class="w-100 form-control form-element"
      [id]="domID"
      [formControlName]="innerInputName"
      [placeholder]="placeholder"
      (keyup.enter)="addValueOnEnter()"
    />
    @if (values.length > 0) {
      <div class="d-flex flex-wrap margin-top-sm">
        @for (value of values; track value; let i = $index) {
          <div [attr.id]="domID + '_selectedValue_' + i" class="value-button">
            <span class="value-button-text text-truncate" [attr.aria-label]="value">
              {{ value }}
            </span>
            <button
              type="button"
              class="my-auto remove-value-btn"
              [attr.aria-describedby]="domID + '_selectedValue_' + i"
              (click)="removeChip(value)"
            >
              <span class="visuallyhidden">{{ 'remove_selected_value' | translate }}</span>
              <svg>
                <use xlink:href="#circle-x"></use>
              </svg>
            </button>
          </div>
        }
      </div>
    }
  </form>
}
